import { render, staticRenderFns } from "./zyk.vue?vue&type=template&id=083dc466&scoped=true"
import script from "./zyk.vue?vue&type=script&lang=js"
export * from "./zyk.vue?vue&type=script&lang=js"
import style0 from "./zyk.vue?vue&type=style&index=0&id=083dc466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dc466",
  null
  
)

export default component.exports